import React, { useCallback, useEffect, useState } from "react";
import classnames from "classnames";

import "./Section.styles.scss";
import { ReactComponent as ChevronIcon } from "../../../assets/icons/chevron.svg";
import { ReactComponent as CommentPlus } from "../../../assets/icons/comment-plus.svg";
import { CustomComponent } from "../../../store/types";
import { CommentInput } from "../Comment-input/CommentInput";
import { useCommentsUrlHooks } from "../../../hooks";
import { useCommentsScrollSelector, useViewActions } from "../../../store";

export interface ISectionBody {
  findTargetRef: FindTargetRefType;
}

export type SectionBodyComponent = CustomComponent<ISectionBody>;
export type FindTargetRefType = (targetRef: HTMLDivElement) => void;

interface ISection {
  isOpen: boolean;
  onClick: () => void;
  title: string;
  hasInputTrigger?: boolean;
  children: (findTargetRef: FindTargetRefType) => React.ReactNode;
}

export const Section: React.FC<ISection> = ({
  isOpen,
  onClick,
  title,
  hasInputTrigger = false,
  children,
}) => {
  const [isInputOpen, setIsInputOpen] = useState<boolean>(false);
  const { commentId } = useCommentsUrlHooks();
  const { commentsScrollAction } = useViewActions();
  const commentsScroll: boolean = useCommentsScrollSelector();

  // =================================================================================

  const [targetRef, setTargetRef] = useState<HTMLDivElement | null>(null);

  const commentScrollHandler = useCallback(() => {
    targetRef?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
    commentsScrollAction(false);
  }, [targetRef, commentsScroll]);

  useEffect(() => {
    if (commentId && commentsScroll && targetRef) {
      setTimeout(() => commentScrollHandler(), 0);
      // commentScrollHandler()
    }
  }, [targetRef, commentId, commentsScroll, commentScrollHandler]);
  // =================================================================================

  return (
    <div className={classnames("section", { "section--closed": !isOpen })}>
      <div
        className={classnames("head", "flex-row-sb-fc", {
          "head--open-input": isInputOpen,
        })}>
        <div className="flex-row-fs-fc" onClick={onClick}>
          <ChevronIcon
            height="9px"
            width="18px"
            fill="#000000"
            className={classnames("chevron", "rotate-180", "scale-click", {
              "rotate-180--active": isOpen,
            })}
          />
          <span className="title one-row-text scale-click">{title}</span>
        </div>
        {hasInputTrigger && (
          <CommentPlus
            onClick={() => setIsInputOpen(true)}
            className="comments__add-icon scale-click"
          />
        )}
      </div>
      {isInputOpen && <CommentInput onCancel={() => setIsInputOpen(false)} />}
      {isOpen && (
        <div
          className={classnames("section__body", {
            "section__body--open-input": isInputOpen,
          })}>
          {children(setTargetRef)}
        </div>
      )}
    </div>
  );
};
